import React,{useState} from "react";
import logo from "../../assets/sidelogogreen.png";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {Changepassword} from "../../redux/actions/InfluencerAction"
import makeToast from "../toster/TosterMessage";

const NavBar = () => {
  const user = JSON.parse(localStorage.getItem("INFLUENCER"));
  const history = useHistory();
  const { addToast } = useToasts();
  const [name,setName] = useState("")
  const [number,setNumber] = useState("")
  const [account,setAccount] = useState("")
  const [code,setCode] = useState("")
  const [beneficiary,setBeneficiary] = useState("")
  const [country,setCountry] = useState("")
  const [oldPassword,setOldPassword] = useState("")
  const [newPassword,setNewPassword] = useState("")
  const [loder,setLoder] = useState(false)

  const LogoutUser = () => {
    localStorage.removeItem("INFLUENCER");
    localStorage.removeItem("INFLUENCER_TOKEN");
    history.push("/affiliate/login");
  };

  const ResetPassword = (e) =>{
      e.preventDefault();
        setLoder(true)
      const data = {
         phoneNumber:user.phoneNumber,
         oldpassword:oldPassword,
         newpassword:newPassword
      }
const onSuccess = (msg) =>{
    setLoder(false)
    addToast(msg, {
        appearance: "success",
        autoDismiss: true,
      });
}
const onError = (msg) =>{
    setLoder(false)
    addToast(msg, {
        appearance: "error",
        autoDismiss: true,
      });
}
      Changepassword(data,onSuccess,onError)
      console.log(data)
    
  }

  const submitBank = async (e) => {
    e.preventDefault();

    try{

      if(number.length!== 10)
      {
        addToast("Enter a valid number")
      }
      else if(code.length!== 11){
        addToast("Enter a valid IFSC code")
      }
      else{

      const response = await fetch('https://v1.nocodeapi.com/clapingo/google_sheets/xkiVwQLOkdmvXtnW?tabId=Sheet1', {
        method:'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify([[name,number,account, code,beneficiary,country, new Date().toLocaleString()]])
      });

      await response.json()
      setName("");
      setNumber("");
      setAccount("");
      setCode("");
      setBeneficiary("");
      setCountry("");
      addToast("Bank Details Submitted");

    }

    } catch(err) {
      console.log(err)
    }
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container">
          <a className="navbar-brand" href="#">
            <img
              src={logo}
              alt=""
              width="35"
              height="35"
              className="d-inline-block img-fluid align-text-top"
            />
            <span className="logo_text m-3">Clapingo Affiliate</span>
          </a>

          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>




          <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0"></ul>
            <ul className="mb-2 mb-lg-0 navbar-nav">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownMenuLink"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fas fa-user fa-2x"></i> {user ? user.name : ""}
                </a>
                <div
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <a
                    className="dropdown-item"
                    href="#"
                    data-toggle="modal"
                    data-target="#exampleModal2"
                  >
                    Enter Bank Details
                  </a>
                  <a
                    className="dropdown-item"
                    href="#"
                    data-toggle="modal"
                    data-target="#exampleModal"
                  >
                    Reset Password
                  </a>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => LogoutUser()}
                  >
                    Logout
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>

    {/* Add bank details */}
    
    <div
        className="modal fade"
        id="exampleModal2"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Bank details
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={(e)=>submitBank(e)}>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    value={name}
                    onChange={(e)=>setName(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="number">Phone Number</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Phone Number"
                    value={number}
                    onChange={(e)=>setNumber(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="bankaccount">Bank Account Number</label>
                  <input

                    type="number"
                    className="form-control"
                    placeholder="Bank Account Number"
                    value={account}
                    onChange={(e)=>setAccount(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="ifsc">IFSC Code</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="IFSC Code"
                    value={code}
                    onChange={(e)=>setCode(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="beneficiary">Beneficiary Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Beneficiary Name"
                    value={beneficiary}
                    onChange={(e)=>setBeneficiary(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="country">Country</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Country"
                    value={country}
                    onChange={(e)=>setCountry(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" disabled={loder} className="btn btn-primary btn-block">
                {loder?"Loading...":"Submit"}
              </button>
              </form>
            </div>
          </div>
        </div>
      </div>

    {/* Reset password */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Reset Your Password
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={(e)=>ResetPassword(e)}>
                <div className="form-group">
                  <label htmlFor="oldpass">Old Password</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Old Password"
                    value={oldPassword}
                    onChange={(e)=>setOldPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="newpass">New Password</label>
                  <input
                    type="Password"
                    className="form-control"
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e)=>setNewPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" disabled={loder} className="btn btn-primary btn-block">
                {loder?"Loading...":"Submit"}
              </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavBar;
